import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * <recently-viewed-products> — renders the shopper's recently viewed products (from
 * localStorage) into a product-recommendations-style section. It fetches the section in a
 * search context (q=id:A OR id:B) so the same card markup/layout is reused, extracts the
 * rendered cards and injects them. The element starts hidden (inline display:none, which
 * beats `.product-recommendations { display: block }`) and is only revealed when there is
 * history AND cards came back — otherwise the whole section stays invisible.
 */
class RecentlyViewedProducts extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#load();
  }

  async #load() {
    const ids = RecentlyViewed.getProducts();
    const { sectionId, searchUrl } = this.dataset;

    if (!ids.length || !sectionId || !searchUrl) return;

    const url = new URL(searchUrl, location.origin);
    url.searchParams.set('q', ids.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);
      if (!html?.trim()) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fetchedList = doc.querySelector('[data-recently-viewed-list]');
      const liveList = this.querySelector('[data-recently-viewed-list]');
      if (!fetchedList || !liveList || fetchedList.children.length === 0) return;

      liveList.replaceWith(this.ownerDocument.importNode(fetchedList, true));
      this.style.display = '';
    } catch (error) {
      // Leave the section hidden on any failure.
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
